const Joi = require('@hapi/joi')

const name = require('./name')(Joi)
const email = require('./email')(Joi)
const uuid = require('./uuid')(Joi)
const password = require('./password')(Joi)

module.exports = {
  name,
  email,
  uuid,
  password
}
